import Xhr from '@Core/xhr'
import to from '@Utils/to'

export default {

  async requestItems ({ commit, state }, payload) {
    if (!state.initialized || (payload && payload.force)) {
      let checkout = state.checkout
      let items = await new Xhr({ checkout }).post('/kosarica')
      commit('setItems', items)
    }
  },

  async addItem ({ commit, state }, { id, qty }) {
    return new Promise(async (resolve, reject) => {
      commit('setLoading', { loading: true })
      let checkout = state.checkout
      let [error, items] = await to(new Xhr({ qty, checkout }).post(`/kosarica/${id}`))
      commit('setLoading', { loading: false })

      !error && commit('setItems', items)

      error
        ? reject(new Error(error.get('default')))
        : resolve({ items })
    })
  },

  async removeItem ({ commit, state }, { id, row }) {
    commit('setLoading', { loading: true })
    let checkout = state.checkout
    let items = await new Xhr({ row, checkout }).post(`/kosarica/destroy/${id}`)
    commit('setLoading', { loading: false })
    commit('setItems', items)
  },

  async updateQty ({ commit, state }, { id, row, qty }) {
    commit('setLoading', { loading: true })
    let checkout = state.checkout
    let items = await new Xhr({ row, qty, checkout }).post(`/kosarica/update/${id}`)
    commit('setLoading', { loading: false })
    commit('setItems', items)
  },

  async applyCoupon ({ commit }, { code }) {
    commit('setLoading', { loading: true })
    let response = await new Xhr({ code }).post(`/coupon/apply`)
    commit('setLoading', { loading: false })

    if (response.success) {
      commit('coupon', { coupon: response.coupon })
      commit('setItems', response.items)
    }
  },

  async removeCoupon ({ commit }) {
    commit('setLoading', { loading: true })
    let response = await new Xhr().post(`/coupon/remove`)
    commit('setLoading', { loading: false })

    if (response.success) {
      commit('coupon', { coupon: null })
      commit('setItems', response.items)
    }
  }

}
